import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IErrorModel } from '../models';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  public constructor(private readonly _toastr: ToastrService) {}
  public intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: HttpRequest<any>,
    next: HttpHandler
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {},
        (error: HttpErrorResponse) => {
          const errorModel: IErrorModel = this.handleHttpError(error);
          this._toastr.error(errorModel.message, errorModel.title); // Display error using Toastr
        }
      )
    );
  }

  private handleHttpError(error: HttpErrorResponse): IErrorModel {
    if (error.error && error.error.message) {
      // Backend error with a custom message
      return {
        title: error.error.title || 'Error',
        message: error.error.message
      };
    } else {
      // General error based on status code
      switch (error.status) {
        case 0: {
          return {
            title: 'Failed to connect to the server',
            message:
              'Could not establish a connection to our server. Please try again in a bit'
          };
        }

        case 400: {
          return {
            title: 'Bad Request',
            message:
              'The request was invalid. Please check your input and try again.'
          };
        }

        case 401: {
          return {
            title: 'You are not authorized to perform this action',
            message:
              'Please login and try again. If the error continues, contact your system administrator.'
          };
        }

        case 500: {
          return {
            title: 'There was a problem while processing your request',
            message:
              'Please try again later, or contact your system administrator'
          };
        }

        default: {
          return {
            title: 'Failed to execute your request',
            message:
              'Please try again later, or contact your system administrator'
          };
        }
      }
    }
  }
}
